var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59375 6.625C6.59375 7.40168 7.22338 8.03125 8 8.03125C8.77662 8.03125 9.40625 7.40168 9.40625 6.625C9.40625 5.84833 8.77662 5.21875 8 5.21875C7.22338 5.21875 6.59375 5.84833 6.59375 6.625ZM8 7.09375C7.74112 7.09375 7.53125 6.88389 7.53125 6.625C7.53125 6.36611 7.74112 6.15625 8 6.15625C8.25888 6.15625 8.46875 6.36611 8.46875 6.625C8.46875 6.88389 8.25888 7.09375 8 7.09375Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3438 10.375C10.3438 11.1517 10.9734 11.7812 11.75 11.7812C12.5266 11.7812 13.1563 11.1517 13.1563 10.375C13.1563 9.59833 12.5266 8.96875 11.75 8.96875C10.9734 8.96875 10.3438 9.59833 10.3438 10.375ZM11.75 10.8437C11.4911 10.8437 11.2813 10.6339 11.2813 10.375C11.2813 10.1161 11.4911 9.90625 11.75 9.90625C12.0089 9.90625 12.2188 10.1161 12.2188 10.375C12.2188 10.6339 12.0089 10.8437 11.75 10.8437Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.0379L12.4129 6.625L11.75 5.96209L7.33709 10.375L8 11.0379Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.6562L16 13.6562V8.96875H15.5312C15.2724 8.96875 15.0625 8.75889 15.0625 8.5C15.0625 8.24111 15.2724 8.03125 15.5312 8.03125H16V3.34375L0 3.34375L0 8.03125H0.46875C0.727627 8.03125 0.9375 8.24111 0.9375 8.5C0.9375 8.75889 0.727627 8.96875 0.46875 8.96875H0L0 13.6562ZM0.9375 12.7188L0.9375 9.82623C1.48367 9.63318 1.875 9.11231 1.875 8.5C1.875 7.88769 1.48367 7.36682 0.9375 7.17377L0.9375 4.28125L15.0625 4.28125V7.17377C14.5163 7.36682 14.125 7.88769 14.125 8.5C14.125 9.11231 14.5163 9.63318 15.0625 9.82623V12.7187L0.9375 12.7188Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 13.6562V11.7812H3.78125L3.78125 13.6562H4.71875Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 10.8438V8.96875H3.78125L3.78125 10.8438H4.71875Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 8.03125V6.15625L3.78125 6.15625L3.78125 8.03125H4.71875Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71875 5.21875V3.34375L3.78125 3.34375L3.78125 5.21875H4.71875Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/Coupon.eec6410423a7ec2c4284dc75ccb45938.svg";
export { ForwardRef as ReactComponent };